module.exports = {
	"name": "iaho",
	"version": "3.1.1",
	"private": true,
	"devDependencies": {
		"@thg303/standard": "^10.0.2",
		"babel-core": "^6.24.1",
		"babel-loader": "^6.2.7",
		"babel-plugin-transform-require-ignore": "^0.1.0",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-react": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"custom-react-scripts": "0.0.21",
		"enzyme": "^2.8.2",
		"eslint": "^3.13.1",
		"json-loader": "^0.5.4",
		"react-test-renderer": "^15.5.4",
		"webpack": "^1.14.0"
	},
	"dependencies": {
		"@thg303/react-persian": "^1.1.0",
		"@thg303/react-persian-datepicker": "^3.0.2",
		"animate.css": "^3.5.2",
		"axios": "^0.15.3",
		"basic-auth": "^1.1.0",
		"bootstrap": "^3.3.7",
		"bootstrap-rtl": "^3.3.4",
		"clipboard": "^1.6.1",
		"express": "^4.15.2",
		"express-winston": "^2.4.0",
		"fade-props": "^1.0.0",
		"font-awesome": "^4.7.0",
		"history": "^4.6.1",
		"jumpstate": "^1.0.7",
		"lodash": "^4.17.4",
		"moment-jalaali": "^0.6.0",
		"offline-js": "^0.7.18",
		"piwik-react-router": "^0.8.2",
		"qs": "^6.3.0",
		"react": "^15.4.2",
		"react-bootstrap": "^0.31.1",
		"react-bootstrap-toggle": "^2.0.4",
		"react-bootstrap-typeahead-ali": "1.0.1",
		"react-cropper": "^0.10.1",
		"react-dom": "^15.4.2",
		"react-fine-uploader": "^0.5.0",
		"react-form": "^1.3.0",
		"react-form-ali": "^0.13.1",
		"react-helmet": "^5.0.3",
		"react-icon-base": "^2.0.4",
		"react-image-lightbox": "^4.1.0",
		"react-persian": "^1.1.1",
		"react-persian-datepicker": "^3.0.2",
		"react-persian-datepicker-ali": "^1.0.0",
		"react-redux": "^5.0.2",
		"react-redux-loading-bar": "^2.6.4",
		"react-redux-toastr": "^6.2.4",
		"react-router": "^3.0.1",
		"react-router-bootstrap": "^0.23.1",
		"react-router-redux": "^4.0.8",
		"react-share": "^1.13.0",
		"react-simple-countdown": "^1.2.1",
		"react-svg-morph": "^0.1.10",
		"react-swipeable-views": "^0.12.4",
		"react-transition-group": "^2.1.0",
		"react-typewriter": "^0.4.1",
		"redux": "^3.6.0",
		"redux-auth-wrapper": "^1.0.0",
		"validatorjs": "^3.11.0",
		"winston": "^2.3.1"
	},
	"scripts": {
		"start": "react-scripts start",
		"test": "standard && react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"build": "npm run build:client && npm run build:server",
		"build:client": "react-scripts build",
		"build:server": "webpack --config ./server/webpack.server.config.js",
		"server": "node ./server/server.bundle.js"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 851
// module chunks = 0